import { InjectionToken } from "@angular/core";
import { GlobalDisableSettings } from "@common-modules/shared/config/global-disable-settings";

export const GLOBAL_DISABLE_SETTINGS = new InjectionToken<GlobalDisableSettings>(
  'GLOBAL_DISABLE_SETTINGS'
);
